
import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";


const fetchCallbacks = (page, search, filterData, supportId) => {

    return useQuery(
        ["get-all-callbacks"],
        () =>
            request({
                url: supportId ? `requestCallback/admin?supportId=${supportId}` : `requestCallback/admin`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                params: search.length > 0 ? {
                    page: page,
                    size: filterData.pageSize || 50,
                    patientName: search,
                    phoneNumber: search,
                    createdAt: filterData.from || null,
                    createdTill: filterData.to || null,
                    additionalDetails: {
                        platform: filterData.platform || null,
                        leadCreationSource: filterData.leadCreationSource || null,
                    },
                    status: filterData.status || null,
                    type: filterData.type || null,
                    leadsWithPrescription: filterData.withPrescription || null,
                } : {
                    page: page,
                    size: filterData.pageSize || 50,
                    createdAt: filterData.from || null,
                    createdTill: filterData.to || null,
                    additionalDetails: {
                        platform: filterData.platform || null,
                        leadCreationSource: filterData.leadCreationSource || null,
                    },
                    status: filterData.status || null,
                    type: filterData.type || null,
                    leadsWithPrescription: filterData.withPrescription || null,
                },
            })

    );
}



export { fetchCallbacks };




